import React from 'react';
// eslint-disable-next-line jira/restricted/lottie
import { useLottie } from '@atlassian/jira-servicedesk-itsm-onboarding-common';
import { LOTTIE_ANIMATION } from './assets/animation';

export const Animation = () => {
	const { lottieDiv } = useLottie(LOTTIE_ANIMATION);

	// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
	return <div ref={lottieDiv} />;
};
